export default __webpack_public_path__ + "static/media/ic_svc_health_platform.3cf35bf4.png";